import { Box, Col, Link, Row, Text } from '@opendoor/bricks-next';
import type { ILpElementLink, ILpElementSimpleList } from 'declarations/contentful';

import { isSimpleLink } from '../../../../cms/utils';
import type { IBNComponentThemeConfig } from '../styles/ComponentTheme';

const FooterNav = ({
  footerNav,
  theme,
}: {
  footerNav?: ILpElementSimpleList[];
  theme: IBNComponentThemeConfig;
}) => {
  return (
    <Col flex={1}>
      <Row
        flexWrap="wrap"
        $largerThanSM={{ flexWrap: 'nowrap' }}
        justifyContent="space-between"
        gap="$12x"
      >
        {footerNav &&
          footerNav.map((navItem, i) => {
            return (
              <Col key={i} flex={1} flexBasis={'45%'} gap="$12x">
                <Text tag="h3" typography="$subheaderSmall" color={theme.contentPrimary}>
                  {navItem.fields.title}
                </Text>
                <Col tag="ul" padding={0} gap="$8x">
                  {(
                    navItem.fields.links?.filter(
                      (link): link is ILpElementLink => link != null && isSimpleLink(link),
                    ) ?? []
                  ).map((link, i) => (
                    <Box tag="li" key={i}>
                      <Link
                        analyticsName={`footer-link-column-${link.fields.text || ''}`}
                        typography="$bodyMedium"
                        href={link.fields.url || ''}
                        variant="secondaryInverse"
                        textDecorationLine="none"
                      >
                        {link.fields.text || ''}
                      </Link>
                    </Box>
                  ))}
                </Col>
              </Col>
            );
          })}
      </Row>
    </Col>
  );
};

export default FooterNav;
